<nav class="sub-nav-container" aria-label="sub-navigation">
    <dxo-button-v2 class="back" *ngIf="returnPath && returnPathType === 'routerLink'" [routerLink]="returnPath"
        queryParamsHandling="preserve" variant="secondary-icon" [size]="buttonSize" icon="chevron_left" aria-label="previus-page">
    </dxo-button-v2>
    <dxo-button-v2 class="back" *ngIf="returnPath && returnPathType === 'href'" [href]="returnPath" aria-label="previous-page"
        variant="secondary-icon" [size]="buttonSize" icon="chevron_left">
    </dxo-button-v2>
    <div class="nav-wrapper">
        <app-breadcrumbs [currentPath]="currentPath" [links]="links" [truncate]="true"></app-breadcrumbs>
    </div>
</nav>